import { motion } from 'framer-motion';
import { useAppDataContext } from '../context/AppDataContext';
import { LEVELS } from '../constants/levels';
import BridgeTrail from '../components/progress/BridgeTrail';
import Glyph from '../components/glyphs/Glyph';

const PLANKS = 10;

export default function ProgressPage() {
  const { profile } = useAppDataContext();

  if (!profile) return <div className="flex items-center justify-center h-full text-muted-foreground bg-background">טוען...</div>;

  const xp = profile.xp || 0;
  const cur = LEVELS.reduce((acc, l) => (xp >= l.minDiamonds ? l : acc), LEVELS[0]);
  const next = LEVELS.find((l) => l.level === cur.level + 1);
  const frac = next ? (xp - cur.minDiamonds) / (next.minDiamonds - cur.minDiamonds) : 1;
  const laid = Math.floor(frac * PLANKS);
  const avatarId = localStorage.getItem('remind_avatar') || profile.avatar_id || 'default';

  return (
    <div className="h-full overflow-y-auto bg-background dir-rtl">
      <header className="sticky top-0 z-20 bg-background/90 backdrop-blur border-b border-border px-5 pt-4 pb-3">
        <div className="flex items-end justify-between gap-3">
          <div>
            <h1 className="font-hand text-4xl leading-none text-foreground">המסע שלי</h1>
            <p className="mt-1 text-sm font-bold text-bridge-foreground">גשר {cur.level} מתוך {LEVELS.length} · {cur.label}</p>
          </div>
          <span className="flex items-center gap-1 text-sm font-bold text-foreground">
            {xp} <Glyph name="diamond" size={16} />
          </span>
        </div>

        {/* the next bridge, being built plank by plank */}
        <div className="mt-3 flex gap-1" role="progressbar" aria-valuemin={0} aria-valuemax={PLANKS} aria-valuenow={laid}
          aria-label={next ? `${laid} מתוך ${PLANKS} קרשים לגשר הבא` : 'הגעת לפסגה'}>
          {Array.from({ length: PLANKS }, (_, i) => (
            <motion.span
              key={i}
              className={`h-3 flex-1 rounded-[3px] border ${i < laid ? 'bg-bridge border-bridge-foreground/30' : 'border-dashed border-muted-foreground/40'}`}
              initial={i < laid ? { scaleY: 0 } : false}
              animate={{ scaleY: 1 }}
              transition={{ delay: 0.04 * i, type: 'spring', stiffness: 300, damping: 18 }}
            />
          ))}
        </div>
        <p className="mt-1.5 text-xs text-muted-foreground">
          {next ? `עוד ${next.minDiamonds - xp} יהלומים והגשר לרמה ${next.level} נפתח: ${next.reward}` : 'הגעת לפסגה. כל הגשרים שלך עומדים.'}
        </p>
      </header>

      <BridgeTrail xp={xp} activeLevel={cur.level} avatarId={avatarId} />
    </div>
  );
}
